import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleRoundDoubleOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M3 7.594V6.11a4 4 0 0 1-.575-.286C1.77 5.42 1.4 4.877 1.4 3.999c0-.918.406-1.485 1.154-1.9C3.387 1.636 4.617 1.4 6 1.4s2.611.236 3.444.699c.692.384 1.092.898 1.147 1.7h1.402C11.862.955 8.93 0 5.999 0 3 0 0 1 0 3.999c0 1.958 1.278 3.063 3 3.595"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m11.167 14.757-.27.19c-.523.373-1.006.722-1.4 1.049v-3.009C6.675 12.88 4 11.83 4 8.997 3.999 6 6.999 5 9.998 5s5.998 1 5.998 3.999c0 2.343-2.675 4.235-4.829 5.759m-.27-1.526V11.64l-1.346-.052c-1.291-.049-2.393-.313-3.127-.765C5.77 10.419 5.4 9.876 5.4 8.998c0-.918.406-1.485 1.154-1.9.833-.463 2.063-.7 3.445-.7s2.611.237 3.444.7c.748.415 1.154.982 1.154 1.9 0 .829-.64 1.785-1.99 2.928a27 27 0 0 1-1.708 1.305"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
BubbleRoundDoubleOutlinedSize16Glyph.displayName = 'BubbleRoundDoubleOutlinedSize16Glyph';
